﻿import { TrialInformationViewModel } from "./Trial.types";
import { useState } from "react";
import { PlanType } from "../auth/planProvider/PlanProvider.types.ts";
import { useDotLegalQueryWithKey } from "@common/hooks/dotLegalReactQuery";

export function useTrialInformationHook() {
    let oneHour = 3600000;
    const [showOverviewOfTrialsDialog, setShowOverviewOfTrialsDialog] = useState(false);
    let { isLoading, data } = useDotLegalQueryWithKey<TrialInformationViewModel>("customerPlan", "/plan/trialinformation/", {
        staleTime: oneHour,
    });

    return {
        isLoading,
        data,
        showOverviewOfTrialsDialog,
        setShowOverviewOfTrialsDialog,
        hasActivePremiumTrial: hasActivePremiumTrial(),
        hasActiveVendorManagementTrial: hasActiveVendorManagementTrial(),
    };

    function hasActivePremiumTrial(): boolean {
        if (data) {
            return data.plansOnTrials.some((x) => !x.isExpired);
        }

        return false;
    }

    function hasActiveVendorManagementTrial(): boolean {
        if (data) {
            return data.plansOnTrials.some((x) => !x.isExpired && x.planType === PlanType.VendorManagement);
        }

        return false;
    }
}
